var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("Header"),
          _c("img", {
            staticClass: "loading",
            attrs: { src: _vm.gameData.topBgImage, alt: "" },
          }),
          _c("div", { staticClass: "item_welfare" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _c("div", { staticClass: "describe" }, [
                  _c("img", {
                    attrs: {
                      src: require("../assets/image/push.png"),
                      alt: "",
                    },
                  }),
                  _c("span", [_vm._v("|")]),
                  _c("p", { staticClass: "marquee" }, [
                    _c("span", [_vm._v(_vm._s(_vm.horseRaceLamp))]),
                  ]),
                ]),
                _c("div", { staticClass: "position" }, [
                  _c("div", { staticClass: "countdown" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/image/alarm1.png"),
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "time" }, [
                      _c("p", [_vm._v(_vm._s(_vm.countdown.d))]),
                      _c("span", [_vm._v("d")]),
                      _c("p", [_vm._v(_vm._s(_vm.countdown.h))]),
                      _c("span", [_vm._v("h")]),
                      _c("p", [_vm._v(_vm._s(_vm.countdown.m))]),
                      _c("span", [_vm._v("m")]),
                      _c("p", [_vm._v(_vm._s(_vm.countdown.s))]),
                      _c("span", [_vm._v("s")]),
                    ]),
                  ]),
                  _c(
                    "ul",
                    _vm._l(_vm.welfareList, function (item, index) {
                      return _c(
                        "li",
                        {
                          class:
                            !_vm.stateList[item.level].buttonDisplay &&
                            _vm.rewardMode == 1
                              ? "disable"
                              : "",
                        },
                        [
                          _c("img", {
                            staticClass: "first",
                            attrs: { src: item.icon, alt: "" },
                          }),
                          _c("div", { staticClass: "welfare_right" }, [
                            _c("p", [
                              _vm._v(_vm._s(item.title) + " "),
                              _c("span", [
                                _vm._v("(" + _vm._s(item.condition) + ")"),
                              ]),
                            ]),
                            _c("p", {
                              staticClass: "prop",
                              domProps: {
                                innerHTML: _vm._s(_vm.cutout(item.describe)),
                              },
                            }),
                            item.amount > 0
                              ? _c(
                                  "div",
                                  { staticClass: "progress-container" },
                                  [
                                    _c("div", { staticClass: "percentage" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stateList[item.level]
                                            .giftResidueRate
                                        ) + "%"
                                      ),
                                    ]),
                                    _c("div", {
                                      staticClass: "progress-bar",
                                      style:
                                        "width:" +
                                        _vm.stateList[item.level]
                                          .giftResidueRate +
                                        "%",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            !item.isDisable
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.stateList[item.level]
                                            .buttonDisplay,
                                        expression:
                                          "stateList[item.level].buttonDisplay",
                                      },
                                    ],
                                    class: [
                                      "receive",
                                      _vm.stateList[item.level]
                                        .buttonDisabled == false
                                        ? "bg_color"
                                        : "",
                                    ],
                                    attrs: {
                                      disabled:
                                        _vm.stateList[item.level]
                                          .buttonDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.receive(item.level)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("claim_text")))]
                                )
                              : _vm._e(),
                            item.isDisable
                              ? _c("button", { staticClass: "receive" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("contact_customer_service_text")
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            !_vm.stateList[item.level].buttonDisplay &&
                            _vm.rewardMode == 0
                              ? _c("div", [
                                  _c("div", { staticClass: "package" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.gfitCodeOverlengthOmit(
                                            _vm.stateList[item.level].giftCode
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "clipboard",
                                          rawName: "v-clipboard:success",
                                          value: _vm.onCopySuccess,
                                          expression: "onCopySuccess",
                                          arg: "success",
                                        },
                                        {
                                          name: "clipboard",
                                          rawName: "v-clipboard:copy",
                                          value:
                                            _vm.stateList[item.level].giftCode,
                                          expression:
                                            "stateList[item.level].giftCode",
                                          arg: "copy",
                                        },
                                      ],
                                      staticClass: "fa fa-clipboard color",
                                    }),
                                  ]),
                                ])
                              : _vm._e(),
                            !_vm.stateList[item.level].buttonDisplay &&
                            _vm.rewardMode == 1
                              ? _c("button", { staticClass: "receive" }, [
                                  _vm._v(_vm._s(_vm.$t("claimed_text"))),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("p", { staticClass: "h3" }, [
                    _vm._v(_vm._s(_vm.$t("instructions_text")) + ":"),
                  ]),
                  _c("p", { staticClass: "instructions" }, [
                    _vm._v(
                      "[" +
                        _vm._s(_vm.gameData.gameName) +
                        "]\n\t\t\t\t\t\tofficial website offers extra top-up rebates. Participate in relevant events on the official\n\t\t\t\t\t\twebsite and you will be able to obtain valued gift packages during the event time. When you\n\t\t\t\t\t\treach the requirement, you can claim the Gift Code on the official website and redeem it in\n\t\t\t\t\t\tthe game. The Gift Code can only be used once. We do not suggesting giving or exposing the\n\t\t\t\t\t\tGift Code to others.\n\t\t\t\t\t"
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
      _c("TipsWindow", { ref: "tips" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }